import { AppButton } from "components/form";
import { AppSpacer } from "components/ui";
import { useStores } from "index";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { ITrackingDiagnostic } from "types/models/TrackingDiagnosticsModel";

interface ITrackingDiagnosticsTableControlProps {
    visibleRows?: ITrackingDiagnostic[];
    allSelectedTrackingDiagnosticIds: string[] | null;
    selectedUploadedCount: number;
    onCreate: () => void;
    onSelect: () => void;
    onCancel: () => void;
}

export const TrackingDiagnosticsTableControl = observer(({ visibleRows, allSelectedTrackingDiagnosticIds, selectedUploadedCount, onCreate, onSelect, onCancel }: ITrackingDiagnosticsTableControlProps) => {
    const { t } = useTranslation();

    const { trackingDiagnosticsStore, diagnosticsPackagesStore } = useStores();

    return (
        <div className='w-100'>
            <div className='d-flex justify-content-end align-items-center w-100'>
                <AppButton
                    variant='secondary'
                    className='border-secondary'
                    onClick={(e) => {
                        e?.stopPropagation();
                        if (visibleRows) {
                            trackingDiagnosticsStore.addRangeSelectedTrackingDiagnosticList(visibleRows);
                        }
                    }}
                    disabled={!visibleRows || visibleRows.length === 0}
                >
                    {t('TrackingDiagnostics.Action.SelectAll')}
                </AppButton>

                <AppSpacer isHorizontal space='1rem' />

                <AppButton
                    variant='secondary'
                    className='border-secondary'
                    onClick={(e) => {
                        e?.stopPropagation();
                        trackingDiagnosticsStore.clearSelectedTrackingDiagnosticList();
                    }}
                    disabled={!allSelectedTrackingDiagnosticIds || allSelectedTrackingDiagnosticIds.length === 0}
                >
                    {t('TrackingDiagnostics.Action.Clear')}
                </AppButton>

                <AppSpacer isHorizontal space='1rem' />

                <AppButton
                    variant='primary'
                    className='border-primary'
                    onClick={(e) => {
                        e?.stopPropagation();
                        onSelect();
                    }}
                    disabled={selectedUploadedCount === 0 || diagnosticsPackagesStore.diagnosticsPackages.length === 0}
                >
                    {t('TrackingDiagnostics.Action.SelectPackage')}
                </AppButton>

                <AppSpacer isHorizontal space='1rem' />

                <AppButton
                    variant='primary'
                    className='border-primary'
                    onClick={(e) => {
                        e?.stopPropagation();
                        onCreate();
                    }}
                    disabled={selectedUploadedCount === 0}
                >
                    {t('TrackingDiagnostics.Action.CreatePackage')}
                </AppButton>

                <AppSpacer isHorizontal space='1rem' />

                <AppButton
                    variant='warning'
                    className='border-warning'
                    onClick={(e) => {
                        e?.stopPropagation();
                        onCancel();
                    }}
                    disabled={!allSelectedTrackingDiagnosticIds || allSelectedTrackingDiagnosticIds.length === 0}
                >
                    {t('TrackingDiagnostics.Action.CancelDiagnostic')}
                </AppButton>
            </div>
            <AppSpacer space='15px' />

            <div className='d-flex justify-content-end align-items-center w-100'
                style={{ visibility: !allSelectedTrackingDiagnosticIds || allSelectedTrackingDiagnosticIds.length === 0 ? 'hidden' : 'visible' }}>
                <p className="font-10 font-700 font-lato text-capitalize color-secondaryGrey mb-0">
                    {t('DiagnosticsPackages.SelectPackage.Message', { amount: `${allSelectedTrackingDiagnosticIds?.length || 0}` })}
                    &nbsp;|&nbsp;
                    {t('DiagnosticsPackages.SelectPackage.ValidMessage', { amount: `${selectedUploadedCount}` })}
                </p>
            </div>
        </div>
    )
});

export default TrackingDiagnosticsTableControl;